module.exports = __webpack_public_path__ + "img/spear.bcc260b3.png";